module.exports = __webpack_public_path__ + "img/paypal.41519ff015cba31d4debb67b0ef53dda.svg";